/* global axios */

import ApiClient from './ApiClient';

class FollowUpRulesAPI extends ApiClient {
    constructor() {
        super('follow_up_rules', { accountScoped: true });
    }

    get() {
        return axios.get(this.url);
    }

    show(id) {
        return axios.get(`${this.url}/${id}`);
    }

    create(data) {
        return axios.post(this.url, { follow_up_rule: data });
    }

    update(id, data) {
        return axios.patch(`${this.url}/${id}`, { follow_up_rule: data });
    }

    delete(id) {
        return axios.delete(`${this.url}/${id}`);
    }

    getWhatsappTemplates(inboxId) {
        return axios.get(`${this.url}/whatsapp_templates`, {
            params: { inbox_id: inboxId },
        });
    }
}

export default new FollowUpRulesAPI();
